import React, { useContext, useMemo } from 'react';
import { get } from 'lodash';
import ConfigContext from '../../contexts/ConfigContext';

const InvoiceRenderer = ({ rowData, dataKey }) => {
  const { t } = useContext(ConfigContext);
  const { firstName, lastName, positionName } = get(rowData, dataKey) || {};

  const valueText = useMemo(() => [firstName, lastName, t(positionName)].filter((cur) => !!cur).join(' '), [
    firstName,
    lastName,
    positionName,
    t
  ]);

  if (!firstName) {
    return <></>;
  }

  return <>{valueText}</>;
};

export default InvoiceRenderer;
